module.exports = __webpack_public_path__ + "static/media/html5.946427f5.jpg";